module.exports = __webpack_public_path__ + "img/form-phone.3a7fe4f7.png";